<template>
    <ul class="handbook-nav">
        <li v-if="parent" :class="{ active: activePages[activePages.length - 1] == parent.id }">
            <ProLink
                :to="{ name: 'handbook-product-all', params: { product: product, pathMatch: requiredVersion + (path ? path : parent.slug) } }"
                class="page-nav-page"
                >{{ $t("global.overview") }}</ProLink
            >
        </li>
        <li v-for="page in navigation" :key="page.id" :class="{ opened: page.opened, active: activePages.includes(page.id) }">
            <button v-if="page.descendants.length" @click="page.opened = !page.opened" class="page-nav-page">
                {{ page.version.title }}
                <ProIcon icon="arrow-right" />
            </button>
            <ProLink
                v-else
                :to="{ name: 'handbook-product-all', params: { product: product, pathMatch: requiredVersion + (path ? `${path}/${page.slug}` : page.slug) } }"
                class="page-nav-page"
                >{{ page.version.title }}</ProLink
            >
            <PageNav
                v-if="page.descendants.length && page.opened"
                :pages="page.descendants"
                :product="product"
                :parent="page"
                :path="path ? `${path}/${page.slug}` : page.slug"
                :active-pages="activePages"
            />
        </li>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "PageNav",
    props: {
        pages: Array,
        parent: Object,
        activePages: Array,
        path: String,
        product: String,
    },
    data: function () {
        return {
            navigation: this.buildNav(),
        };
    },
    computed: {
        ...mapGetters({
            defaultVersion: "handbook/getDefaultVersion",
            currentVersion: "handbook/getCurrentVersion",
            currentProduct: "handbook/getCurrentProduct",
        }),
        requiredVersion() {
            if (this.currentVersion !== this.defaultVersion) {
                return this.currentVersion.slug + "/";
            }

            return "";
        },
    },
    methods: {
        buildNav() {
            return this.pages.map((page) => ({
                ...page,
                opened: this.activePages.includes(page.id),
            }));
        },
    },
    watch: {
        pages() {
            this.navigation = this.buildNav();
        },
    },
};
</script>
